export default "__VITE_ASSET__DUFcmu4M__"